import { defineMessages } from "react-intl";

export const pagesListSearchAndFiltersMessages = defineMessages({
  searchPlaceholder: {
    id: "nP8iex",
    defaultMessage: "Search Content",
    description: "search content placeholder",
  },
});
